import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Main from "layouts/Main";
import Page404 from "pages/Page404";
import Top, { NotificationList } from "pages/Top";
import Shift from "pages/Shift";
import Signin from "pages/Signin";
import EmergencyCall from "pages/EmergencyCall";
import Payoff from "pages/Payoff";
import GuestNoteList from "pages/GuestNoteList";
import GuestNote from "pages/GuestNote";
import Order from "pages/Order";
import InOuts from "pages/InOut";
import ShiftConfirm from "pages/ShiftConfirm";
import { useSelector } from "react-redux";
import OrderHistory from "pages/OrderHistory";
import ResetPasswordSend from "pages/ResetPasswordSend";
import ResetPassword from "pages/ResetPassword";
import Setting from "pages/Setting";
import NewOrder from "pages/NewOrder";
import usePageTracking from "hooks/usePageTracking";

type RouteType = {
  path: string;
  component: React.FC<any>;
  exact?: boolean;
};

type Routes = {
  [key: string]: RouteType;
};

const mainRoutes: Routes = {
  top: {
    path: "/",
    component: Top,
    exact: true,
  },
  shift: {
    path: "/shift",
    component: Shift,
  },
  order: {
    path: "/order",
    component: Order,
  },
  inoutOrderId: {
    path: "/inout/:orderId",
    component: InOuts,
  },
  inout: {
    path: "/inout",
    component: InOuts,
  },
  newOrder: {
    path: "/newOrder",
    component: NewOrder,
  },
  shiftConfirm: {
    path: "/shift_confirm",
    component: ShiftConfirm,
  },
  emergency: {
    path: "/emergency",
    component: EmergencyCall,
  },
  payoff: {
    path: "/payoff",
    component: Payoff,
  },
  guestNote: {
    path: "/guestNote/:id",
    component: GuestNote,
  },
  guestNoteList: {
    path: "/guestNoteList",
    component: GuestNoteList,
  },
  news: {
    path: "/news",
    component: NotificationList,
  },
  orderHistory: {
    path: "/orderHistory/:id",
    component: OrderHistory,
  },
  setting: {
    path: "/setting",
    component: Setting,
  },
};

const unauthorizedRoutes: Routes = {
  ResetPasswordSend: {
    path: "/resetPassword/send",
    component: ResetPasswordSend,
  },
  ResetPassword: {
    path: "/resetPassword",
    component: ResetPassword,
  },
  signin: {
    path: "/login",
    component: Signin,
  },
};
const configureRoutes = (
  Layout: React.FC,
  routes: Routes,
  redirect?: string
) => {
  const components = Object.values(routes).map(
    ({ component: Component, path, exact = false }, index) => (
      <Route
        key={index}
        path={path}
        exact={exact}
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    )
  );

  if (redirect) {
    components.push(<Redirect key="redirect" to={redirect} />);
  }

  return components;
};

const Auth: React.FC = ({ children }) => {
  const isLoggedin = useSelector((state) => Boolean(state.account.accessToken));
  usePageTracking();

  return (
    <Switch>
      {isLoggedin
        ? children
        : configureRoutes(Main, unauthorizedRoutes, "/login")}
    </Switch>
  );
};

const Routes: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Auth>{configureRoutes(Main, mainRoutes, "/")}</Auth>
        <Route render={() => <Page404 />} />
      </Switch>
    </Router>
  );
};

export default Routes;
